// Disciplinas principales
export const DISCIPLINES = {
  ACROBATIC: 'acrobatic',
  ARTISTIC: 'artistic',
  RHYTHMIC: 'rhythmic',
  TRAMPOLINE: 'trampoline',
  AEROBIC: 'aerobic',
  GYMNASTICS_FOR_ALL: 'gymnastics_for_all',
  PARKOUR: 'parkour'
};

export const DISCIPLINE_NAMES = {
  acrobatic: 'Gimnasia Acrobática',
  artistic: 'Gimnasia Artística',
  rhythmic: 'Gimnasia Rítmica',
  trampoline: 'Gimnasia de Trampolín',
  aerobic: 'Gimnasia Aeróbica',
  gymnastics_for_all: 'Gimnasia Para Todos',
  parkour: 'Parkour'
};

// Tabs de disciplinas con logos (para selección visual)
export const DISCIPLINE_TABS = [
  { key: 'acrobatic', discipline: 'acrobatic', category: '', name: 'ACRO', fullName: 'Gimnasia Acrobática', logo: '/acro.png' },
  { key: 'artistic-wag', discipline: 'artistic', category: 'wag', name: 'GAF', fullName: 'Artística Femenina', logo: '/gaf.png' },
  { key: 'artistic-mag', discipline: 'artistic', category: 'mag', name: 'GAM', fullName: 'Artística Masculina', logo: '/gam.png' },
  { key: 'gymnastics-for-all', discipline: 'gymnastics_for_all', category: '', name: 'GPT', fullName: 'Gimnasia Para Todos', logo: '/gpt.png' },
  { key: 'rhythmic', discipline: 'rhythmic', category: '', name: 'GR', fullName: 'Gimnasia Rítmica', logo: '/gr.png' },
  { key: 'trampoline', discipline: 'trampoline', category: '', name: 'GT', fullName: 'Gimnasia de Trampolín', logo: '/gt.png' },
  { key: 'aerobic', discipline: 'aerobic', category: '', name: 'AER', fullName: 'Aeróbica', logo: '/aer.png' },
  { key: 'parkour', discipline: 'parkour', category: '', name: 'PK', fullName: 'Parkour', logo: '/pk.png' },
];

// Categorías por disciplina
export const CATEGORIES_BY_DISCIPLINE = {
  acrobatic: {
    women_pair: 'Pareja Femenina',
    men_pair: 'Pareja Masculina',
    mixed_pair: 'Pareja Mixta',
    women_group: 'Grupo Femenino',
    men_group: 'Grupo Masculino'
  },
  artistic: {
    wag: 'Femenina (WAG)',
    mag: 'Masculina (MAG)'
  },
  rhythmic: {
    individual: 'Individual',
    groups: 'Conjuntos'
  },
  trampoline: {
    individual: 'Individual',
    synchronized: 'Sincronizado',
    tumbling: 'Tumbling',
    double_mini: 'Doble Mini Trampolín'
  },
  aerobic: {
    individual: 'Individual',
    mixed_pairs: 'Parejas Mixtas',
    trios: 'Tríos',
    groups: 'Grupos'
  },
  gymnastics_for_all: {
    team_gym: 'TeamGym',
    display: 'Exhibición'
  },
  parkour: {
    speed: 'Speed Run',
    freestyle: 'Freestyle'
  }
};

// Aparatos/Pruebas por disciplina y categoría
export const EVENTS_BY_DISCIPLINE = {
  acrobatic: {
    women_pair: [
      { code: 'balance', name: 'Ejercicio de Balance', apparatus: 'balance' },
      { code: 'dynamic', name: 'Ejercicio Dinámico', apparatus: 'dynamic' },
      { code: 'combined', name: 'Ejercicio Combinado', apparatus: 'combined' }
    ],
    men_pair: [
      { code: 'balance', name: 'Ejercicio de Balance', apparatus: 'balance' },
      { code: 'dynamic', name: 'Ejercicio Dinámico', apparatus: 'dynamic' },
      { code: 'combined', name: 'Ejercicio Combinado', apparatus: 'combined' }
    ],
    mixed_pair: [
      { code: 'balance', name: 'Ejercicio de Balance', apparatus: 'balance' },
      { code: 'dynamic', name: 'Ejercicio Dinámico', apparatus: 'dynamic' },
      { code: 'combined', name: 'Ejercicio Combinado', apparatus: 'combined' }
    ],
    women_group: [
      { code: 'balance', name: 'Ejercicio de Balance', apparatus: 'balance' },
      { code: 'dynamic', name: 'Ejercicio Dinámico', apparatus: 'dynamic' },
      { code: 'combined', name: 'Ejercicio Combinado', apparatus: 'combined' }
    ],
    men_group: [
      { code: 'balance', name: 'Ejercicio de Balance', apparatus: 'balance' },
      { code: 'dynamic', name: 'Ejercicio Dinámico', apparatus: 'dynamic' },
      { code: 'combined', name: 'Ejercicio Combinado', apparatus: 'combined' }
    ]
  },
  artistic: {
    wag: [
      { code: 'team', name: 'Equipo femenino', apparatus: 'team' },
      { code: 'aa', name: 'All Around individual', apparatus: 'all_around' },
      { code: 'vt', name: 'Salto', apparatus: 'salto' },
      { code: 'ub', name: 'Barras asimétricas', apparatus: 'barras_asimetricas' },
      { code: 'bb', name: 'Viga de equilibrio', apparatus: 'viga' },
      { code: 'fx', name: 'Suelo', apparatus: 'suelo' }
    ],
    mag: [
      { code: 'team', name: 'Equipo masculino', apparatus: 'team' },
      { code: 'aa', name: 'All Around individual', apparatus: 'all_around' },
      { code: 'fx', name: 'Suelo', apparatus: 'suelo' },
      { code: 'ph', name: 'Caballo con arzones', apparatus: 'caballo' },
      { code: 'sr', name: 'Anillas', apparatus: 'anillas' },
      { code: 'vt', name: 'Salto', apparatus: 'salto' },
      { code: 'pb', name: 'Barras paralelas', apparatus: 'barras_paralelas' },
      { code: 'hb', name: 'Barra fija', apparatus: 'barra_fija' }
    ]
  },
  rhythmic: {
    individual: [
      { code: 'aa', name: 'All Around individual', apparatus: 'all_around' },
      { code: 'hoop', name: 'Aro', apparatus: 'aro' },
      { code: 'ball', name: 'Pelota', apparatus: 'pelota' },
      { code: 'clubs', name: 'Mazas', apparatus: 'mazas' },
      { code: 'ribbon', name: 'Cinta', apparatus: 'cinta' }
    ],
    groups: [
      { code: 'aa', name: 'All Around conjunto', apparatus: 'all_around' },
      { code: 'hoops', name: '5 Aros', apparatus: '5_aros' },
      { code: 'mix', name: '3 Cintas + 2 Pelotas', apparatus: 'mix_cinta_pelota' }
    ]
  },
  trampoline: {
    individual: [
      { code: 'male', name: 'Individual masculino', apparatus: 'individual_m' },
      { code: 'female', name: 'Individual femenino', apparatus: 'individual_f' }
    ],
    synchronized: [
      { code: 'male', name: 'Sincronizado masculino', apparatus: 'sync_m' },
      { code: 'female', name: 'Sincronizado femenino', apparatus: 'sync_f' }
    ],
    tumbling: [
      { code: 'male', name: 'Tumbling masculino', apparatus: 'tumbling_m' },
      { code: 'female', name: 'Tumbling femenino', apparatus: 'tumbling_f' }
    ],
    double_mini: [
      { code: 'male', name: 'Doble Mini masculino', apparatus: 'dmt_m' },
      { code: 'female', name: 'Doble Mini femenino', apparatus: 'dmt_f' }
    ]
  },
  aerobic: {
    individual: [
      { code: 'male', name: 'Individual masculino', apparatus: 'individual_m' },
      { code: 'female', name: 'Individual femenino', apparatus: 'individual_f' }
    ],
    mixed_pairs: [
      { code: 'pairs', name: 'Parejas mixtas', apparatus: 'pairs' }
    ],
    trios: [
      { code: 'trios', name: 'Tríos', apparatus: 'trios' }
    ],
    groups: [
      { code: 'groups', name: 'Grupos', apparatus: 'groups' }
    ]
  },
  gymnastics_for_all: {
    team_gym: [
      { code: 'floor', name: 'Suelo TeamGym', apparatus: 'floor_teamgym' },
      { code: 'tumbling', name: 'Tumbling TeamGym', apparatus: 'tumbling_teamgym' },
      { code: 'mini_tramp', name: 'Mini Trampolín TeamGym', apparatus: 'mini_tramp_teamgym' }
    ],
    display: [
      { code: 'display', name: 'Exhibición', apparatus: 'display' }
    ]
  },
  parkour: {
    speed: [
      { code: 'male', name: 'Speed Run masculino', apparatus: 'speed_m' },
      { code: 'female', name: 'Speed Run femenino', apparatus: 'speed_f' }
    ],
    freestyle: [
      { code: 'male', name: 'Freestyle masculino', apparatus: 'freestyle_m' },
      { code: 'female', name: 'Freestyle femenino', apparatus: 'freestyle_f' }
    ]
  }
};

// Niveles de competencia
export const LEVEL_OPTIONS = [
  'Baby Gym',
  'Minis', 
  'Iniciación 1', 
  'Iniciación 2',
  'Nivel 1 - Iniciación',
  'Nivel 2 - Principiante',
  'Nivel 3 - Intermedio',
  'Nivel 4 - Intermedio Avanzado',
  'Nivel 5 - Avanzado',
  'Nivel 6 - Alto Rendimiento',
  'Nivel 7 - Élite',
  'Nivel 8 - Profesional',
  'Nivel 9 - Internacional',
  'Nivel 10 - FIG',
  'Pre-infantil',
  'Infantil',
  'Juvenil',
  'Junior',
  'Senior'
];

export const FRANJA_OPTIONS = ['Franja 1', 'Franja 2', 'Franja 3'];

export const CATEGORY_OPTIONS = [
  'Baby Gym',
  'Pre-Mini',
  'Mini',
  'Pre-Infantil',
  'Infantil',
  'Juvenil',
  'Junior',
  'Senior',
  'Avanzado',
  'General',
  'Élite',
  'Open',
];

// =============================================
// NIVELES DE COMPETENCIA / TIPO DE EVENTO
// =============================================
export const COMPETITION_LEVELS = [
  { code: 'club_interno', label: 'Club Interno', description: 'Competencia interna de un club' },
  { code: 'interclub', label: 'Interclub', description: 'Competencia entre clubes locales' },
  { code: 'municipal', label: 'Municipal', description: 'Nivel municipal' },
  { code: 'estatal', label: 'Estatal / Regional', description: 'Nivel estatal o regional' },
  { code: 'copa_regional', label: 'Copa Regional', description: 'Copa regional oficial' },
  { code: 'nacional', label: 'Nacional', description: 'Campeonato nacional' },
  { code: 'copa_nacional', label: 'Copa Nacional', description: 'Copa nacional oficial' },
  { code: 'centroamericano', label: 'Centroamericano', description: 'Nivel centroamericano' },
  { code: 'panamericano', label: 'Panamericano', description: 'Nivel panamericano' },
  { code: 'continental', label: 'Continental', description: 'Campeonato continental' },
  { code: 'mundial', label: 'Mundial', description: 'Campeonato mundial FIG' },
  { code: 'olimpico', label: 'Olímpico', description: 'Juegos Olímpicos' },
  { code: 'particular', label: 'Particular / Exhibition', description: 'Evento particular o exhibición' },
];

// =============================================
// TIPOS DE JUEZ FIG
// =============================================
export const JUDGE_ROLES = [
  { code: 'D', label: 'Panel D — Dificultad', description: 'Evalúa el valor de dificultad de la rutina' },
  { code: 'E', label: 'Panel E — Ejecución', description: 'Evalúa la calidad técnica de ejecución (parte de 10)' },
  { code: 'A', label: 'Panel A — Artístico', description: 'Evalúa el componente artístico y presentación' },
  { code: 'L', label: 'Juez de Línea', description: 'Evalúa salidas de área y infracciones de línea' },
  { code: 'T', label: 'Juez de Tiempo', description: 'Controla el tiempo de la rutina' },
  { code: 'R', label: 'Juez de Referencia / Superior', description: 'Juez principal supervisor' },
];

// =============================================
// CONFIGURACIÓN ESTÁNDAR DE JUECES POR NIVEL DE COMPETENCIA
// Cantidad recomendada de jueces por panel
// =============================================
export const JUDGES_CONFIG_BY_LEVEL = {
  club_interno:    { D: 1, E: 2, A: 0, L: 0, T: 0, R: 0, trim: false },
  interclub:       { D: 1, E: 3, A: 0, L: 0, T: 0, R: 0, trim: false },
  municipal:       { D: 1, E: 3, A: 0, L: 1, T: 0, R: 0, trim: false },
  estatal:         { D: 2, E: 4, A: 0, L: 1, T: 0, R: 1, trim: true },
  copa_regional:   { D: 2, E: 4, A: 0, L: 1, T: 1, R: 1, trim: true },
  nacional:        { D: 2, E: 5, A: 0, L: 1, T: 1, R: 1, trim: true },
  copa_nacional:   { D: 2, E: 5, A: 0, L: 1, T: 1, R: 1, trim: true },
  centroamericano: { D: 2, E: 5, A: 2, L: 1, T: 1, R: 1, trim: true },
  panamericano:    { D: 2, E: 6, A: 2, L: 2, T: 1, R: 1, trim: true },
  continental:     { D: 2, E: 6, A: 2, L: 2, T: 1, R: 1, trim: true },
  mundial:         { D: 2, E: 6, A: 2, L: 2, T: 1, R: 1, trim: true },
  olimpico:        { D: 2, E: 6, A: 2, L: 2, T: 1, R: 1, trim: true },
  particular:      { D: 1, E: 3, A: 0, L: 0, T: 0, R: 0, trim: false },
};

// =============================================
// FÓRMULAS DE CÁLCULO POR DISCIPLINA
// =============================================
// Describe qué paneles usa cada disciplina y cómo combinarlos
export const SCORING_FORMULA_BY_DISCIPLINE = {
  artistic: {
    name: 'GAM / GAF',
    formula: 'D + E_trimmed − P',
    panels: ['D', 'E', 'P'],
    has_artistic: false,
    description: 'Final = D-Score + Promedio E (sin extremos) − Penalizaciones'
  },
  rhythmic: {
    name: 'Rítmica',
    formula: 'D + E_trimmed + A_trimmed − P',
    panels: ['D', 'E', 'A', 'P'],
    has_artistic: true,
    description: 'Final = D-Score + Promedio E + Promedio A − Penalizaciones'
  },
  aerobic: {
    name: 'Aeróbica',
    formula: 'D + E_avg + A_avg − P',
    panels: ['D', 'E', 'A', 'P'],
    has_artistic: true,
    description: 'Final = D + Promedio E + Promedio A − Penalizaciones'
  },
  acrobatic: {
    name: 'Acrobática',
    formula: 'D + E_trimmed + A_avg − P',
    panels: ['D', 'E', 'A', 'P'],
    has_artistic: true,
    description: 'Final = D + Promedio E (sin extremos) + Promedio A − Penalizaciones'
  },
  trampoline: {
    name: 'Trampolín',
    formula: 'D + E_trimmed + ToF + HD − P',
    panels: ['D', 'E', 'P'],
    has_artistic: false,
    extra_components: ['time_of_flight', 'horizontal_displacement'],
    description: 'Final = D + Promedio E (sin extremos) + Tiempo vuelo + H.D. − Penalizaciones'
  },
  parkour: {
    name: 'Parkour',
    formula_speed: 'Tiempo + P',
    formula_freestyle: 'D + E + A − P',
    panels: ['D', 'E', 'A', 'P'],
    has_artistic: true,
    description: 'Speed: Tiempo + Penalizaciones | Freestyle: D + E + A − P'
  },
  gymnastics_for_all: {
    name: 'Gimnasia Para Todos',
    formula: 'D + E_avg + A_avg − P',
    panels: ['D', 'E', 'A', 'P'],
    has_artistic: true,
    description: 'Final = D + Promedio E + Promedio A − Penalizaciones'
  }
};

// =============================================
// PENALIZACIONES ESTÁNDAR FIG
// =============================================
export const STANDARD_PENALTIES = [
  { code: 'fall', label: 'Caída', value: -1.0, description: 'Caída del aparato o al suelo' },
  { code: 'step_small', label: 'Paso pequeño', value: -0.1, description: 'Paso pequeño en la recepción' },
  { code: 'step_large', label: 'Paso grande', value: -0.3, description: 'Paso grande en la recepción' },
  { code: 'out_of_bounds', label: 'Fuera de área', value: -0.1, description: 'Salida del área de competencia (por línea)' },
  { code: 'time_over', label: 'Exceso de tiempo', value: -0.1, description: 'Exceso de tiempo permitido' },
  { code: 'time_under', label: 'Tiempo insuficiente', value: -0.1, description: 'Rutina por debajo del tiempo mínimo' },
  { code: 'attire', label: 'Vestimenta', value: -0.3, description: 'Infracción de vestimenta' },
  { code: 'coach_assist', label: 'Asistencia de coach', value: -0.5, description: 'Asistencia del entrenador durante la rutina' },
  { code: 'custom', label: 'Otra', value: 0, description: 'Penalización personalizada' },
];

// Aparatos antiguos (mantener para compatibilidad)
export const APPARATUS_OPTIONS = ['Suelo', 'Viga', 'Barras', 'Salto'];

// Vistas
export const VIEWS = {
  PUBLIC: 'public',
  ADMIN: 'admin',
  SCORES: 'scores',
  CLUBS: 'clubs',
  JUDGES: 'judges',
  ANALYTICS: 'analytics'
};
